import React, {Component} from "react"
import {Link} from "react-router-dom"
import {snakeCase} from "lodash"

import moment from "moment"
import {transactionTypes} from "~/utils/ShelfEntities"
import {withTranslation} from "react-i18next"

class ListItemTransaction extends Component {
  render() {
    const transactionTypeData = transactionTypes(this.props.t)[
      this.props.transaction_type
    ]
    const date = moment(this.props.created_at)

    const typeSnakeCase = snakeCase(this.props.transaction_type)
    const detailUrl = "/transaction/" + typeSnakeCase + "/" + this.props.id

    return (
      <div className="sh-list-item">
        <img src={transactionTypeData.icon} alt={"Transaktion"} />
        <div className="content">
          <Link to={detailUrl}>
            <div className="primary">{transactionTypeData.name}</div>
            <div className="secondary simplified">
              <span>{this.props.article.barcode}</span>
              <span>{this.props.article.name}</span>
              <span>{this.props.user.email}</span>
            </div>
          </Link>
        </div>

        <div className="date">
          {this.props.t("timestamp", {
            timestamp: date.format("D.M.YYYY – H:mm")
          })}
        </div>
      </div>
    )
  }
}

export default withTranslation()(ListItemTransaction)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemTransaction.js